import { createSlice } from '@reduxjs/toolkit';
import { fetchMyApplicationsThunk } from '@/modules/candidate/store/myApplications.thunk';
import type { MyApplicationsState } from '@/modules/candidate/types/candidateApplication.types';

const initialState: MyApplicationsState = {
  items: [],
  loading: false,
  error: null,
};

const myApplicationsSlice = createSlice({
  name: 'myApplications',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMyApplicationsThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMyApplicationsThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchMyApplicationsThunk.rejected, (state, action: any) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch applications.';
      });
  },
});

export default myApplicationsSlice.reducer;